export const isDate = date =>
  Object.prototype.toString.call(date) === '[object Date]'

const respond = (number, label, prefix = 'a') =>
  number === 1 ? `${prefix} ${label} ago` : `${number} ${label}s ago`

export const relativeDate = (date, now = Date.now()) => {
  if (!isDate) date = new Date(date)
  let diff = now - date
  if (diff < 0) diff = 0
  const minutes = Math.floor(diff / 60000)
  if (minutes === 0) {
    return 'just now'
  }
  if (minutes < 60) {
    return respond(minutes, 'minute')
  }
  const hours = Math.floor(minutes / 60)
  if (hours < 24) {
    return respond(hours, 'hour', 'an')
  }
  const days = Math.floor(hours / 24)
  if (days < 7) {
    return respond(days, 'day')
  }
  const weeks = Math.floor(days / 7)
  if (weeks === 1) {
    return 'a week ago'
  }
  if (days < 30) {
    return respond(weeks, 'week')
  }
  const months = Math.floor(days / 30)
  if (months < 12) {
    return respond(months, 'month')
  }
  const years = Math.floor(months / 12)
  return respond(years, 'year')
}
